import { createSelector } from 'reselect';
import { getAssets, isCIAMSyncFlag, isRefreshPowertrains } from '../../../GeneralFilter/GeneralFilterModal/selectors';

export const getPowertrainOverviewList = ({ conditionIndicesV2 }) => {
    return conditionIndicesV2?.powertrains?.data;
};

const getPowertrainOverviewLoadingStatus = ({ conditionIndicesV2 }) => {
    return conditionIndicesV2?.powertrains?.loadingStatus;
};

const getPageNumber = ({ conditionIndicesV2 }) => {
    return conditionIndicesV2?.powertrains?.pageNumber;
};

const getHasMore = ({ conditionIndicesV2 }) => {
    return conditionIndicesV2?.powertrains?.hasMore;
};
const getShowThreshold = ({ conditionIndicesV2 }) => {
    return conditionIndicesV2?.powertrains?.showThreshold;
};
const getShowTrend = ({ conditionIndicesV2 }) => {
    return conditionIndicesV2?.powertrains?.showTrend;
};
const getInitialLoadDone = ({ conditionIndicesV2 }) => {
    return conditionIndicesV2?.powertrains?.initialLoadDone;
};
const getSelectedAsset = ({ conditionIndicesV2 }) => {
    return conditionIndicesV2?.selectedAsset;
};

export const getModel = createSelector(
    [
        getPowertrainOverviewList,
        getPowertrainOverviewLoadingStatus,
        getPageNumber,
        getShowThreshold,
        getShowTrend,
        getHasMore,
        getInitialLoadDone,
        getAssets,
        getSelectedAsset,
        isCIAMSyncFlag,
        isRefreshPowertrains
    ],
    (
        powertrainOverviewList,
        powertrainOverviewLoadingStatus,
        pageNumber,
        showThreshold,
        showTrend,
        hasMore,
        initialLoadDone,
        overviewAssetList,
        selectedAsset,
        refeshCIAMSync,
        refreshPowertrains
    ) => {
        return {
            powertrainOverviewList,
            powertrainOverviewLoadingStatus,
            pageNumber,
            showThreshold,
            showTrend,
            hasMore,
            initialLoadDone,
            overviewAssetList,
            selectedAsset,
            refeshCIAMSync,
            refreshPowertrains
        };
    }
);
